export const PatientDetailStyles = {
  table: {
    style: {
      border: "1px solid #FFF",
      borderRadius: 2,
      background: "#FFF",
      paddingBottom: "40px",
      fontFamily: "Poppins",

      '.rdt_TableBody': {
        marginTop: '8px'
      },
      '.rdt_TableRow': {
        marginTop: '8px'
      }
    },
  },
  header: {
    style: {
      color: "rgba(0, 0, 0, 0.8)",
      // color: theme.text.primary,
      minHeight: "56px",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  headRow: {
    style: {
      backgroundColor: '#ECEFF1',
      borderRadius: '8px',
      minHeight: "40px",
      padding: '8px 16px',
      borderBottomColor: '#fff',
    },
    denseStyle: {
      minHeight: "32px",
    },
  },
  headCells: {
    style: {
      fontSize: 12,
      fontWeight: "500 !important",
      color: "#0E0F10",
    },
  },
  rows: {
    style: {
      fontSize: "13px",
      minHeight: "56px",
      padding: '8px 16px',
      borderRadius: '8px',
      boxShadow: '0px 2px 10px 0px #5B87EF33',
      borderBottomWidth: '0px !important',
      
      "&:hover": {
        cursor: 'default !important'
      }
    },
    denseStyle: {
      minHeight: "56px",
    },
    selectedHighlightStyle: {
      // use nth-of-type(n) to override other nth selectors
      "&:nth-of-type(n)": {
        color: '#0E0F10',
        // color: defaultThemes.selected.text,
        // backgroundColor: defaultThemes.selected.default,
      },
    },
    highlightOnHoverStyle: {
      // color: defaultThemes.highlightOnHover.text,
      // backgroundColor: defaultThemes.highlightOnHover.default,
      transitionDuration: "0.15s",
      transitionProperty: "background-color",
      // borderBottomColor: defaultThemes.background.default,
      outlineStyle: "solid",
      outlineWidth: "0px",
      // outlineColor: defaultThemes.background.default,
    },
    stripedStyle: {
      // color: defaultThemes.striped.text,
      // backgroundColor: defaultThemes.striped.default,
    },
  },
  cells: {
    style: {
      // paddingTop: 8,
      // paddingBottom: 8,
      color: '#0E0F10',
    },
  },
  pagination: {
    style: {
      // color: defaultThemes.text.secondary,
      fontSize: "13px",
      minHeight: "56px",
      backgroundColor: "#FAFAFA",
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      // borderTopColor: defaultThemes.divider.default,
    },
    pageButtonsStyle: {
      borderRadius: "50%",
      height: "40px",
      width: "40px",
      padding: "8px",
      margin: "px",
      cursor: "pointer",
      transition: "0.4s",
      // color: defaultThemes.button.default,
      // fill: defaultThemes.button.default,
      backgroundColor: "transparent",
      "&:disabled": {
        cursor: "unset",
        // color: defaultThemes.button.disabled,
        // fill: defaultThemes.button.disabled,
      },
      "&:hover:not(:disabled)": {
        // backgroundColor: defaultThemes.button.hover,
      },
      "&:focus": {
        outline: "none",
        // backgroundColor: defaultThemes.button.focus,
      },
    },
  },
};
